export const appInfo = {
  title: 'Báo cáo',
};
